import React from 'react';
import { Error } from '~/Components';
import { Route } from '~/Constants/Routes.constants';
import { useNavigation, useOrganisation } from '~/Hooks';
import { PrivateLayout } from '~/Layout/PrivateLayout';

import { JumpingLoader } from '~/UIKit';
export const OrganisationContainer = () => {
  const { isOrganisationLoading, organisation, organisationError } = useOrganisation();
  const { navigate } = useNavigation();

  if (isOrganisationLoading) {
    return <JumpingLoader />;
  }

  const goToProviderDashboard = () => {
    navigate(Route.PROVIDER_ROOT);
  };

  return (
    <PrivateLayout title={organisation?.name}>
      <Error error={organisationError} errorAction={goToProviderDashboard} />
    </PrivateLayout>
  );
};
